import { render, staticRenderFns } from "./AnimatedNumber.vue?vue&type=template&id=2a6605f8&scoped=true"
import script from "./AnimatedNumber.vue?vue&type=script&lang=ts"
export * from "./AnimatedNumber.vue?vue&type=script&lang=ts"
import style0 from "./AnimatedNumber.vue?vue&type=style&index=0&id=2a6605f8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6605f8",
  null
  
)

export default component.exports